/* -----------------Globals--------------- */
import { isWeb } from "@memorang/helpers/platform";
import { useMemo } from "react";

import { Image } from "expo-image";
/* -----------------UI--------------- */

/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "../../useDevice";

/* -----------------Types--------------- */
import type { GetMessageActions } from "./types";

/* -----------------Child components--------------- */
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import { MessageActions } from "./MessageActions";
import { MessageMenuActions } from "./MessageMenuActions";

type Props = {
	showSummaryActions?: boolean;
	content?: string;
	subheader?: string;
	profileImageUri?: string | null;
	messageActions?: GetMessageActions;
	runId?: string;
};

export const MessageHeader = ({
	showSummaryActions,
	content,
	subheader,
	profileImageUri,
	messageActions,
	runId,
}: Props) => {
	const { isMobile } = useDevice();

	const profileImage = useMemo(() => {
		if (!profileImageUri) {
			return null;
		}

		return (
			<Image
				{...(isWeb ? {} : { cachePolicy: "memory-disk" })}
				source={{
					uri: profileImageUri,
					width: 24,
				}}
				alt="AILA icon"
				accessibilityLabel="AILA icon"
				// * This fixes the flickering of image on web
				placeholder={{
					uri: profileImageUri,
					width: 24,
				}}
				style={{
					borderRadius: 6,
					width: 24,
					height: 24,
				}}
			/>
		);
	}, [profileImageUri]);

	const showSubheader = subheader && subheader.length > 0;
	return (
		<Box flexDirection="row" alignItems="center" justifyContent="space-between">
			{showSubheader ? (
				<Box flexDirection="row" alignItems="center" gap={8}>
					{profileImage}
					<CustomListSubheader
						enableGutters={false}
						style={{
							paddingVertical: 8,
						}}
					>
						{subheader}
					</CustomListSubheader>
				</Box>
			) : (
				<Box />
			)}
			{showSummaryActions &&
				messageActions &&
				(isMobile ? (
					<MessageMenuActions
						messageActions={messageActions}
						content={content}
						runId={runId}
					/>
				) : (
					<MessageActions
						messageActions={messageActions}
						content={content}
						runId={runId}
					/>
				))}
		</Box>
	);
};
